// extracted by mini-css-extract-plugin
export default {"wrapper":"VolumeShareTableChartTotalLabel_wrapper__cWqck"};